

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo/dist";
import {IPermissionMap} from "@/store/modules/permissionsModule";
import PermissionMapDialog from "@/components/settings/permissions/PermissionMapDialog.vue";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

const permissionsModule = namespace("permissionsModule");

  @Component({
    components: {PermissionMapDialog}
  })
  export default class PermissionMapEditor extends Vue {

    @permissionsModule.Getter('permissionTargets')
    private permissionTargets!: string[];
    @permissionsModule.Getter('actionTargets')
    private actionTargets!: string[];
    @permissionsModule.Getter('permissionMaps')
    private permissionMaps!: IPermissionMap[];

    private subscribes: IOnOffHandlers = {};

    private mapCodeTexts: any = {
      '1': 'Y',
      '2': '#',
      '3': 'D',
    };

    protected dialogAction: string = '';
    protected dialogShowing: boolean = false;
    protected showOnlyPermission: string|null = null;

    get headers() {
      let headers = Object.keys(this.permissionTargets).map((eachPermission: any) => ({
        text: '' + eachPermission + ' ' + this.$t('settings.permissions.permissions.' + eachPermission + '.title'),
        value: eachPermission,
        sortable: false,
        class: this.showOnlyPermission ? '' : 'datatable-header-vertical',
        align: "center",
        slotName: 'header.' + eachPermission,
      }));
      headers = headers.filter((each) => ((this.showOnlyPermission == null) || (this.showOnlyPermission == each.value)));
      headers.unshift({
        text: 'action',
        value: 'action',
        sortable: false,
        class: 'vertical-align-bottom',
        align: 'begin',
        slotName: 'header.action',
      });
      return headers;
    }

    get items() {
      const permissionTargets = this.permissionTargets;
      const actionTargets = this.actionTargets;
      const permissionMaps = this.permissionMaps;

      const ret: any[] = Object.keys(actionTargets).map((eachAction: string) => {
        const inn: any = {
          action: eachAction,
          actionGroup: eachAction.split('/')[0],
        };
        Object.keys(permissionTargets).forEach((eachPermission: string) => {
          let v = '-';
          const m = permissionMaps.find((each: IPermissionMap) => ((each.action == eachAction) && (''+each.permission == eachPermission)));
          if (m) {
            v = this.mapCodeTexts[m.code];
          }
          inn[eachPermission] = v;
        });
        return inn;
      });
      return ret;
    }

    created() {
      this.loadData(true);
      this.subscribes = this.$ons({
        'login.OK': this.loadData,
      });
    }

    beforeDestroy() {
      this.$offs(this.subscribes);
    }

    private loadData(initial: boolean = false) {
      this.$store.dispatch('permissionsModule/fetchActionTargets');
      this.$store.dispatch('permissionsModule/fetchPermissionTargets');
      this.$store.dispatch('permissionsModule/fetchPermissionMaps');
    }

    protected tableRowClicked(row: any) {
      this.dialogAction = row.action;
      this.dialogShowing = true;
    }

    protected onHeaderClicked(item: BetterDataTableHeader) {
      this.showOnlyPermission = this.showOnlyPermission ? null : item.value;
    }

  }
